
import state from './moduleDoctorState.js';
import mutations from './moduleDoctorMutations.js';
import actions from './moduleDoctorActions.js';
import getters from './moduleDoctorGetters.js';

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters,
};
